import { render } from "./ScreenRearrangementOverlay.vue?vue&type=template&id=5ac00966"
import script from "./ScreenRearrangementOverlay.vue?vue&type=script&lang=js"
export * from "./ScreenRearrangementOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__